import React from "react";
import { motion } from "framer-motion";

const shots = [
  {
    src: "https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=1200&q=80",
    cap: "Congresso Nacional · registros de arquivo",
  },
  {
    src: "https://images.unsplash.com/photo-1523995462485-3d171b5c8fa9?w=1200&q=80",
    cap: "Imprensa brasileira · manchetes históricas",
  },
  {
    src: "https://images.unsplash.com/photo-1495020689067-958852a7765e?w=1200&q=80",
    cap: "Documentos públicos · processos judiciais",
  },
  {
    src: "https://images.unsplash.com/photo-1589216532372-1c2a367900d9?w=1200&q=80",
    cap: "Tribunais superiores · decisões judiciais",
  },
  {
    src: "https://images.unsplash.com/photo-1569407228235-9051b206bd57?w=1200&q=80",
    cap: "Esplanada dos Ministérios · Brasília",
  },
  {
    src: "https://images.unsplash.com/photo-1518544801976-3e159e50e5bb?w=1200&q=80",
    cap: "Manifestações populares · registros históricos",
  },
];

export default function Gallery() {
  return (
    <section className="relative bg-black py-24 md:py-36 border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mb-14 flex items-end justify-between flex-wrap gap-6">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="h-[1px] w-10 bg-red-600" />
              <span className="eyebrow">Arquivo visual</span>
            </div>
            <h2 className="font-display font-black text-neutral-50 leading-[0.95] tracking-[-0.02em] text-4xl md:text-6xl">
              Uma trajetória <span className="text-red-600 italic">em imagens</span>.
            </h2>
          </div>
          <p className="max-w-sm text-neutral-500 text-[13px] md:text-sm leading-relaxed">
            Composição editorial baseada em arquivos públicos. Cada imagem é uma referência
            contextual — não uma afirmação histórica isolada.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-6 gap-3 md:gap-4 auto-rows-[160px] md:auto-rows-[220px]">
          {shots.map((s, i) => {
            const spans = [
              "col-span-2 row-span-2 md:col-span-3 md:row-span-2",
              "col-span-2 md:col-span-3 md:row-span-1",
              "md:col-span-2",
              "md:col-span-2",
              "md:col-span-2",
              "col-span-2 md:col-span-6",
            ];
            return (
              <motion.figure
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, delay: i * 0.07 }}
                className={`${spans[i]} group relative overflow-hidden border border-white/10 bg-[#0a0a0a]`}
              >
                <img
                  src={s.src}
                  alt={s.cap}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] group-hover:scale-110"
                  style={{ filter: "grayscale(100%) contrast(1.1) brightness(0.7)" }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                <div className="absolute inset-0 bg-red-900/10 opacity-0 group-hover:opacity-100 transition-opacity mix-blend-multiply" />
                <figcaption className="absolute bottom-4 left-5 right-5 font-mono text-[10px] tracking-[0.25em] uppercase text-neutral-300">
                  <span className="text-red-500">[arquivo]</span> {s.cap}
                </figcaption>
              </motion.figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}
